import { render, staticRenderFns } from "./BrandCategoryForm.vue?vue&type=template&id=21c9ceb5&"
import script from "./BrandCategoryForm.vue?vue&type=script&lang=js&"
export * from "./BrandCategoryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports